import React, { createContext, useRef } from 'react';

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
    const formikRef = useRef();
    const isSubmitting = useRef(false);

    const handleSubmit = () => {
        if (formikRef.current && !isSubmitting.current) {
            isSubmitting.current = true;
            const result = formikRef.current.handleSubmit();
            setTimeout(() => {
                isSubmitting.current = false;
            }, 1000);
            return result;
        }
        return Promise.resolve();
    };

    const resetSubmitting = () => {
        isSubmitting.current = false;
    };

    return (
        <FormContext.Provider value={{ formikRef, handleSubmit, resetSubmitting }}>
            {children}
        </FormContext.Provider>
    );
};
